import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxGlideModule } from 'ngx-glide';
import { HomepageService } from 'src/app/shared/services/homepage/homepage.service';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-stories-v2',
  standalone: true,
  imports: [
    CommonModule,
    NgxGlideModule,
    SwiperModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './success-stories-v2.component.html',
  styleUrls: ['./success-stories-v2.component.scss']
})
export class SuccessStoriesV2Component {


  info = {
    title: 'Impact created by Ketto',
    createImpactBtnLabel: 'Create Impact Like This'
  }
  successStories = [];

  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    initialSlide: 1,
    navigation: false,
    keyboard: false,
    scrollbar: false,
    loop: false,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
      waitForTransition: true
    },
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: true,
    pagination: false,
    breakpoints: {
      992: {
        slidesPerView: 1,
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
          waitForTransition: true
        },
        observer: true,
      },
      768: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
          waitForTransition: true
        },
        initialSlide: 2,
        loop: true,
        centeredSlides: true,
        slidePrevClass: 'prev-slide',
        slideActiveClass: 'active-slide',
        slideNextClass: 'next-slide',
        observer: true,
      }
    }
  };

  breakpoints = {
    600: { perView: 1.1, focusAt: 0, showArrows: false },
    992: { perView: 1, focusAt: 0 },
    768: { perView: 1, focusAt: 0 }
  };

  successStoriesObservable;
  isMobile;

  constructor(
    private homepageService: HomepageService,
    public utilService: UtilService,
    public variablesService: VariablesService,
    private router: Router,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.getSuccessStories();
    if (this.isMobile) {
      this.info.title = 'Impactful Journeys';
    }
  }

  ngOnDestroy() {
    if (this.successStoriesObservable) {
      this.successStoriesObservable.unsubscribe();
    }
  }

  getSuccessStories() {
    this.successStoriesObservable = this.homepageService.getSuccessStories().subscribe((res: any) => {
      this.successStories = res.data.data;
    });
  }

  getBannerImage(story): string {
    if (this.isMobile && story.mobile && story.mobile.cdn_path) {
      return story.mobile.cdn_path + '?w=auto';
    } else if (story.desktop && story.desktop.cdn_path) {
      return story.desktop.cdn_path + '?w=auto';
    } else {
      return this.utilService.defaultImg;
    }
  }

  routeToBrowseFundraiser() {
    this.router.navigate(['/crowdfunding/fundraisers']);
    this.events.sendSystemEvent({
      eventName: 'click_on_banner',
      info_1: 'bottom_fold',
      pageName: this.variablesService.pageName
    }).subscribe(_ => _);
  }
}
